/**
 * Escalera de ofertas (blocks/la-oferta.liquid).
 * No añade al carrito por su cuenta: rellena el formulario de Horizon (input "id" y "selling_plan")
 * y deja que el tema añada, abra el carrito y actualice la barra fija.
 */
class LaOferta extends HTMLElement {
  connectedCallback() {
    this.details = this.closest('.product-details') || document;
    this.onChange = this.onChange.bind(this);
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
    this.addEventListener('change', this.onChange);
    document.addEventListener('variant:update', this.onVariantUpdate);
    this.moverDebajoDelBoton();

    this.selectorBarra();
    this.marcarMayorDescuento();

    const marcada = this.tarjetas('.la-tarjeta__radio:checked')[0] || this.tarjetas('.la-tarjeta__radio')[0];
    if (marcada) {
      marcada.checked = true;
      this.aplicar(marcada.closest('.la-tarjeta'), { inicial: true });
    }
  }

  /**
   * La caja del Ritual (otro producto) va debajo del botón de añadir (Tati, 30/09).
   * Se saca del fieldset y se pone justo después del bloque de botones; sigue siendo una opción más.
   */
  moverDebajoDelBoton() {
    if (this.hasAttribute('data-no-mover')) { this.fuera = []; return; }
    this.fuera = [...this.querySelectorAll('.la-tarjeta--producto')];
    // Justo después del botón, o de los iconos de envío si van debajo del botón.
    const botones = this.details.querySelector('.buy-buttons-block');
    const iconos = this.details.querySelector('.la-envio-iconos')?.closest('.shopify-block');
    const ancla = iconos && botones && (botones.compareDocumentPosition(iconos) & Node.DOCUMENT_POSITION_FOLLOWING) ? iconos : botones;
    if (!this.fuera.length || !ancla) { this.fuera = []; return; }
    const caja = document.createElement('div');
    caja.className = 'la-oferta-fuera';
    caja.append(...this.fuera);
    ancla.after(caja);
  }

  /** Las tarjetas que son opciones (las de dentro del fieldset). */
  tarjetas(sel = '.la-tarjeta') {
    // La caja del Ritual (movida debajo del botón) ya no es una opción: tiene su propio "Añadir".
    return [...this.querySelectorAll(sel)];
  }

  /** El badge % más alto de la página se resalta (Luis, 28/09). */
  marcarMayorDescuento() {
    const badges = [...this.querySelectorAll('.la-tarjeta__descuento')];
    const valor = (b) => Number(b.dataset.pct) || Number((b.textContent.match(/\d+/) || [0])[0]);
    const max = Math.max(0, ...badges.map(valor));
    badges.forEach((b) => b.classList.toggle('is-max', max > 0 && valor(b) === max));
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    document.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onChange(event) {
    const radio = event.target.closest('.la-tarjeta__radio');
    if (!radio) return;
    this.aplicar(radio.closest('.la-tarjeta'), { inicial: false });
  }

  /** Horizon vuelve a pintar el botón tras cambiar de variante: reponemos nuestro texto. */
  onVariantUpdate() {
    const tarjeta = this.tarjetas('.la-tarjeta.is-open')[0];
    if (tarjeta) requestAnimationFrame(() => this.textoBoton(tarjeta));
  }

  /** A17 · En la barra fija, un selector con las mismas opciones que las tarjetas (WF12). */
  selectorBarra() {
    const hueco = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__variant');
    if (!hueco || hueco.dataset.laSelector) return;
    hueco.dataset.laSelector = '';
    const select = document.createElement('select');
    select.className = 'la-barra-selector';
    select.setAttribute('aria-label', 'Opción');
    for (const r of this.tarjetas('.la-tarjeta__radio')) {
      const t = r.closest('.la-tarjeta');
      const o = new Option(`${t.querySelector('.la-tarjeta__titulo').textContent.trim()} · ${t.dataset.precio}`, r.value);
      select.add(o);
    }
    select.addEventListener('change', () => {
      const r = this.tarjetas('.la-tarjeta__radio').find((x) => x.value === select.value);
      if (r) r.click();
    });
    hueco.replaceChildren(select);
    this.barraSelect = select;
  }

  aplicar(tarjeta, { inicial }) {
    if (!tarjeta) return;
    for (const t of this.tarjetas()) t.classList.toggle('is-open', t === tarjeta);
    const radio = tarjeta.querySelector('.la-tarjeta__radio');
    if (this.barraSelect && radio) this.barraSelect.value = radio.value;

    const tipo = tarjeta.dataset.tipo;
    const form = this.details.querySelector('form[data-type="add-to-cart-form"]');

    if (tipo === 'variante') {
      this.galeria(null);
      this.quitarPlan(form);
      // Marca la misma variante en el selector de Horizon (oculto) para que cambien fotos, precio e id.
      const picker = this.details.querySelector('variant-picker');
      const input = picker &&
        [...picker.querySelectorAll('input[type="radio"]')].find((i) => i.value === tarjeta.dataset.option);
      if (input && !input.checked && !inicial) input.click();
      if (form && form.elements.id) form.elements.id.value = tarjeta.dataset.variantId;
    } else {
      // Suscripción u otro producto: mismo formulario, otra variante / plan.
      if (form && form.elements.id) form.elements.id.value = tarjeta.dataset.variantId;
      if (tipo === 'suscripcion' && tarjeta.dataset.sellingPlan) this.ponerPlan(form, tarjeta.dataset.sellingPlan);
      else this.quitarPlan(form);
      this.galeria(tipo === 'otro_producto' ? tarjeta.dataset.galeria : null);
    }
    this.textoBoton(tarjeta);
  }

  textoBoton(tarjeta) {
    const base = this.dataset.boton || 'AÑADIR AL CARRITO';
    // Sin stock: botón gris que pone "AGOTADO" y no deja añadir (Tati, 30/09).
    this.agotado = tarjeta.dataset.disponible === 'false';
    this.texto = this.agotado ? 'AGOTADO' : `${base} · ${tarjeta.dataset.precio}`;
    this.bloqueado = this.agotado || (tarjeta.dataset.tipo === 'suscripcion' && !tarjeta.dataset.sellingPlan);
    // Botón de la ficha y botón de la barra fija (A17). La app de preventas (Restock Rocket) reescribe
    // el botón después de cargar: lo vigilamos y reponemos el texto del brief (E9).
    const botones = document.querySelectorAll('.product-details [ref="addToCartButton"], sticky-add-to-cart [ref="addToCartButton"]');
    for (const boton of botones) {
      this.escribir(boton);
      if (!boton.laObservado) {
        boton.laObservado = true;
        new MutationObserver(() => this.escribir(boton)).observe(boton, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      }
    }
  }

  escribir(boton) {
    if (!this.texto) return;
    // Suscripción sin plan (aún no hay app): no se puede comprar como compra única por error.
    if (boton.disabled !== this.bloqueado) boton.disabled = this.bloqueado;
    boton.classList.toggle('la-boton-agotado', !!this.agotado);
    // Solo el texto: el contador de cantidad (ref="quantityDisplay") que usa Shopify se queda.
    const el = boton.querySelector('.add-to-cart-text__content > span:not([ref])') || boton.querySelector('.add-to-cart-text__content') || boton;
    if (el.textContent.trim() !== this.texto) el.textContent = this.texto;
  }

  /**
   * Plan de suscripción propio. No borramos el selling_plan que meta otra app (la preventa de
   * Restock Rocket): mientras hay suscripción lo desactivamos (no viaja en el formulario) y al
   * volver a una compra normal lo reactivamos.
   */
  ponerPlan(form, plan) {
    if (!form) return;
    for (const otro of form.querySelectorAll('input[name="selling_plan"]:not([data-la-plan])')) {
      otro.disabled = true;
      otro.dataset.laDesactivado = '';
    }
    let input = form.querySelector('input[data-la-plan]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.dataset.laPlan = '';
      form.appendChild(input);
    }
    input.value = plan;
  }

  quitarPlan(form) {
    if (!form) return;
    form.querySelector('input[data-la-plan]')?.remove();
    for (const otro of form.querySelectorAll('input[data-la-desactivado]')) {
      otro.disabled = false;
      delete otro.dataset.laDesactivado;
    }
  }

  /** A7b: al marcar el Ritual en la página de la Crema/Bálsamo se ven las fotos del Ritual. */
  galeria(clave) {
    const media = document.querySelector('.product-information__media');
    if (!media) return;
    media.querySelector('.la-oferta-galeria')?.remove();
    media.classList.toggle('la-media--otra', Boolean(clave));
    if (!clave) return;
    const tpl = this.querySelector(`template[data-la-galeria="${clave}"]`);
    if (!tpl) return;
    const galeria = tpl.content.firstElementChild.cloneNode(true);
    const principal = galeria.querySelector('[data-la-principal]');
    galeria.addEventListener('click', (e) => {
      const b = e.target.closest('[data-la-src]');
      if (b && principal) {
        principal.removeAttribute('srcset');
        principal.src = b.dataset.laSrc;
      }
    });
    media.appendChild(galeria);
  }
}

if (!customElements.get('la-oferta')) customElements.define('la-oferta', LaOferta);

// Botón (i) de la suscripción: abre la ventanita con la explicación.
document.addEventListener('click', (e) => {
  const abrir = e.target.closest('[data-la-info]');
  if (abrir) {
    e.preventDefault(); e.stopPropagation();
    document.querySelector('[data-la-info-dialogo]')?.showModal();
    return;
  }
  const dlg = e.target.closest('[data-la-info-dialogo]');
  if (e.target.closest('[data-la-info-cerrar]') || (dlg && e.target === dlg)) dlg?.close();
});
